import { SVGInterface } from "../../interface";

const MicOff = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10.7199 5.38999C10.7199 4.72999 11.2599 4.18999 11.9199 4.18999C12.5799 4.18999 13.1199 4.72999 13.1199 5.38999L13.1099 9.29999L14.9199 11.09V5.48999C14.9199 3.82999 13.5799 2.48999 11.9199 2.48999C10.3799 2.48999 9.12992 3.64999 8.95992 5.13999L10.7199 6.89999V5.38999ZM18.9199 11.49H17.2199C17.2199 12.07 17.1199 12.62 16.9499 13.13L18.2199 14.4C18.6599 13.52 18.9199 12.53 18.9199 11.49ZM4.32992 3.34999L2.91992 4.75999L8.91992 10.76V11.49C8.91992 13.15 10.2599 14.49 11.9199 14.49C12.1499 14.49 12.3599 14.46 12.5699 14.41L14.2299 16.07C13.5199 16.4 12.7299 16.59 11.9199 16.59C9.15992 16.59 6.61992 14.49 6.61992 11.49H4.91992C4.91992 14.9 7.63992 17.72 10.9199 18.21V21.49H12.9199V18.21C13.8299 18.08 14.6899 17.76 15.4699 17.31L19.6699 21.51L21.0799 20.1L4.32992 3.34999Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default MicOff;
